const setIsMyQuizAnswersLoadedAction = (store, isLoaded) => {
  store.commit('setIsMyQuizAnswersLoaded', isLoaded)
}

const setMyQuizAnswersAction = (store, payload) => {
  store.commit('setMyQuizAnswers', payload)
}

export default {
  setIsMyQuizAnswersLoadedAction,
  setMyQuizAnswersAction,
}
